import { z } from "zod";
import { DateValidation } from "../shared/date-validation";

export const SupportCaseItemSchema = z.object({
  Id: z.string().uuid(),
  Number: z.string().nullable().optional(),
  Title: z.string().nullable().optional(),
  StatusCode: z.number().int(),
  StateCode: z.number().int().optional(),
  Created: DateValidation,
  BusinessUnitName: z.string().nullable().optional(),
  BusinessUnitId: z.string().uuid().nullable().optional(),
  PriorityName: z.string().nullable().optional(),
  PriorityCode: z.number().int().nullable().optional(),
  ProductId: z.string().uuid().nullable().optional(),
  ProductFamilyName: z.string().nullable().optional(),
  Description: z.string().nullable().optional(),
  EmailAddress: z.string().email().nullable().optional(),
  Email: z.string().email().nullable().optional(),
  ContactName: z.string().nullable().optional(),
  ContactId: z.string().uuid().nullable().optional(),
  ContactPhone: z.string().nullable().optional(),
  Phone: z.string().nullable().optional(),
  SubjectName: z.string().nullable().optional(),
  SubjectId: z.string().uuid().nullable().optional(),
  PrimaryContactId: z.string().uuid().nullable().optional(),
  AccountId: z.string().uuid().nullable().optional(),
  AccountName: z.string().nullable().optional(),
  CustomerId: z.string().uuid().nullable().optional(),
  KnowledgeArticleId: z.string().uuid().nullable().optional(),
  BrowserVersion: z.string().nullable().optional(),
  CasePriority: z.string().nullable().optional(),
  CaseType: z.string().nullable().optional(),
  IsChangeRequest: z.boolean().nullable().optional(),
  CloseDate: DateValidation,
  DueDate: DateValidation,
  Message: z.string().nullable().optional(),
  ProblemSolved: z.boolean().nullable().optional(),
  IsResolved: z.boolean().nullable().optional(),
  ServerForm: z.string().nullable().optional(),
  UserAgent: z.string().nullable().optional(),
  Version: z.string().nullable().optional(),
  IsClosable: z.boolean().optional(),
  IsLocked: z.boolean().optional(),
});

export type SupportCaseItemType = z.infer<typeof SupportCaseItemSchema>;
